<template>
  <div>
    <el-row class="container mb-100" v-if="showClient">
      <el-col
        :span="layoutBreakpoint.isMobile ? 24 : 12"
        class="client-confirm"
      >
        <h2 class="title text-uppercase text-left pt-60">
          {{ $t("checkout.commander") }}
        </h2>
        <div class="mt-20 flex" style="display: block-inline">
          <el-image :src="images.success.src" :fit="'contain'" />
          <h3 class="text-left mt-2 ml-10">
            {{ $t("checkout.clientConfirm.orderMade") }}
          </h3>
        </div>
        <p
          class="pl-35 mt-50"
          v-html="$t('checkout.clientConfirm.description')"
        ></p>
      </el-col>
      <el-col
        :span="layoutBreakpoint.isMobile ? 0 : 9"
        class="pl-30 pt-20 pb-40 mt-125 text-left right-part"
      >
        <h2 class="text-uppercase text-left right-title">
          {{ $t("checkout.clientConfirm.rightTitle") }}
        </h2>
        <p
          class="mt-20 mb-20"
          v-html="$t('checkout.clientConfirm.rightDescription')"
        ></p>
        <el-button type="primary" @click="goTo('/account')">
          {{ $t("checkout.clientConfirm.buttonText") }}
        </el-button>
      </el-col>
    </el-row>
    <el-row class="container mb-100" v-if="showGuest">
      <el-col
        :span="layoutBreakpoint.isMobile ? 24 : 12"
        class="client-confirm"
      >
        <h2 class="title text-uppercase text-left pt-60">
          {{ $t("checkout.commander") }}
        </h2>
        <div class="mt-20 flex" style="display: block-inline">
          <el-image :src="images.success.src" :fit="'contain'" />
          <h3 class="text-left mt-2 ml-10">
            {{ $t("checkout.guestConfirm.orderMade") }}
          </h3>
        </div>
        <p
          class="pl-35 mt-50"
          v-html="$t('checkout.guestConfirm.description')"
        ></p>
      </el-col>
      <el-col
        :span="layoutBreakpoint.isMobile ? 0 : 9"
        class="pl-20 pr-20 pt-20 pb-40 mt-100 text-left right-part"
      >
        <h2 class="text-uppercase text-left right-title">
          {{ $t("checkout.guestConfirm.rightTitle") }}
        </h2>
        <p
          class="mt-20 mb-20"
          v-html="$t('checkout.guestConfirm.rightDescription')"
        ></p>
        <RegisterComponent
          id="guest-register"
          :cta-submit-text="$t('checkout.guestConfirm.buttonText')"
          :cta-custom-class="'text-left mt-15'"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import imgSuccess from "@/assets/images/checkout/success.svg";
import layoutUtils from "@/utils/layout-utils";
import RegisterComponent from "@/views/user/components/register-form.vue";
import goTo from "../../mixins/goTo";
import { mapState, mapGetters } from "vuex";

export default {
  mixins: [goTo],
  components: {
    RegisterComponent,
  },
  data() {
    return {
      images: {
        success: {
          src: imgSuccess,
        },
      },
      showClient: false,
      showGuest: false,
    };
  },
  computed: {
    layoutBreakpoint() {
      return layoutUtils.layoutBreakpoint(this.$mq);
    },
    ...mapState("user", ["user"]),
    ...mapGetters("user", ["isLoggedIn"]),
  },
  mounted() {
    setTimeout(() => {
      this.checkLogin();
    }, 1000);
  },
  methods: {
    checkLogin() {
      if (this.isLoggedIn) {
        this.showClient = true;
      } else {
        this.showGuest = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.client-confirm {
  .sub-title {
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    letter-spacing: 0.15px;
    color: rgba(39, 36, 33, 0.6980392156862745);
  }
}
.right-part {
  background-color: rgba(237, 240, 237, 0.32941176470588235);
  .right-title {
    font-size: 24px;
  }
  .registerForm {
    .ctaSubmit {
      width: 170px !important;
    }
  }
}
</style>
